<div class="flex flex-row items-center justify-between gap-4 pr-4">
  <div class="s_rol flex flex-row justify-start content-center items-center h-full gap-2">
    <app-search-bar class="fleet_search xs:basis-full gt-xs:grow-0 gt-xs:shrink gt-xs:basis-[300px]"
      placeholder="Search Name or ID Number" inputId="fleet-search"
      (filterChange)="filterData($event)"></app-search-bar>
    <div class="m-r-8 flex grow-0 shrink-0 basis-4" style="align-self: center">
      <app-icon icon="filter" aria-label="filter" role="button" class="pointer"></app-icon>
    </div>
    <mat-form-field class="combowidth grow-0 shrink basis-[180px]">
      <mat-select id="provisioned-org-select" value="" [(ngModel)]="selectedOrgId" class="m-t-0 pro-mat-select"
        (selectionChange)="filterChange()" disableOptionCentering>
        <mat-option *ngFor="let type of orgDDList" [value]="type.Key">
          {{ type.Value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="combowidth grow-0 shrink basis-[180px]">
      <mat-select id="provisioned-status-select" value="" [(ngModel)]="selectedStatusId" class="m-t-0 pro-mat-select"
        (selectionChange)="filterChange()" disableOptionCentering>
        <mat-option *ngFor="let type of statusList" [value]="type.Key">
          {{ type.Value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex gap-4 items-center">
    <button mat-mini-fab class="!bg-transparent !shadow-none hover:!bg-gray-200" (click)="refreshDevices()" aria-label="Refresh Provisioned Devices">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
<div class="flex flex-row">
  <div class="p-l-16 p-r-16 basis-full">
    <div class="fleet_scroll">
      <mat-accordion class="pro_table" [multi]="true" >
        <!-- Common Table Header -->
        <table #tblProvisionedHeader mat-table [dataSource]="packagerList" matSort #sort="matSort"
          matSortActive="idName" matSortDirection="asc" class="prepro_table header-table" tabindex="0" role="table">
          <!-- Common Column Definitions -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="w-[300px] max-w-[300px]">
              <span class="accordion-collapse">
                <img (click)="toggleAccordion()" [class.collapsed-accordion-icon]="accordionCollapsed" src="../../../../../assets/img/icons/ico.12.states.svg" class="icon-states" alt="accordion-toggle" >
              </span>
              <span style="padding-left:8px">Name</span>
            </th>
          </ng-container>
          <ng-container matColumnDef="site">
            <th mat-header-cell *matHeaderCellDef class="w-[200px] max-w-[200px]">Site</th>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="w-[200px] max-w-[200px]">ID Number</th>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="w-[200px] max-w-[200px]">Status</th>
          </ng-container>
          <ng-container matColumnDef="heartbeat">
            <th mat-header-cell *matHeaderCellDef class="w-[200px] max-w-[200px]">CDC Heartbeat</th>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        </table>
        <div class="pro-table-content" [style.height.px]="offsetFromBottom">
          <table class="no-result" *ngIf="provisionedList?.data?.length==0">
            <tr>
              <td [attr.colspan]="displayedColumns.length">
                <span>No data exists</span>
              </td>
            </tr>
          </table>
          <ng-container *ngIf="showHierarchy; else flatList">
            <ng-container *ngFor="let element of displayedRootDevices">
              <ng-container *ngTemplateOutlet="devicePanel; context: { $implicit: element, level: 0 }"></ng-container>
            </ng-container>
          </ng-container>
          <ng-template #flatList>
            <mat-expansion-panel togglePosition="before" [expanded]="true" *ngFor="let element of provisionedList.data">
              <ng-container *ngTemplateOutlet="devicePanel; context: { $implicit: element, level: 0 }"></ng-container>
            </mat-expansion-panel>
          </ng-template>

          <ng-template #devicePanel let-device let-level="level">
            <mat-expansion-panel class="device-level-{{level}}" togglePosition="before" [expanded]="level < 1" [hideToggle]="!(device.systems?.length || device.children?.length)">
              <mat-expansion-panel-header (click)="toggleRow(device)" [ngClass]="{'offline': device.connectionState !== 'Online'}">
                <mat-panel-title>
                  <span class="flex basis-[90%]">
                    <span class="cls-orgname">
                      <img class="alert-icon" [style.visibility]="device.connectionState === 'Online' ? 'hidden' : 'visible'" src="../../../../../assets/img/icons/ico.16.alert.svg" alt="Alert">
                      <span [innerHTML]="(getDeviceDisplayName(device)) | uppercase | noHtml | highlightMatched: filterText"></span>
                    </span>
                    <span class="cls-status">{{device?.connectionState}}</span>
                  </span>
                  <span class="span-ip">{{ device.ipAddress}}</span>
                  <span class="text-right basis-[10%]">
                    <button [matMenuTriggerFor]="provisionedMenu" class="btn-transparent p-0 device-menu" (menuOpened)="onDeviceMenuOpened(device)" (click)="$event.stopPropagation()" (keypress.enter)="$event.stopPropagation()" type="button" tabindex="0" [id]="device?.customerId" aria-label="Action Menu">
                      <mat-icon class="pointer menu-trigger">
                        <img src="../../../../../assets/img/icons/ico_16_Menu.svg" alt="">
                      </mat-icon>
                    </button>
                    <mat-menu #provisionedMenu="matMenu" [backdropClass]="['custom_drop', 'provisioned-menu-backdrop']" xPosition="before">
                      <button mat-menu-item type="button" (click)="downloadLogs(device.edgeDeviceId)" *ngIf="device.connectionState == 'Online'">Pull Logs</button>
                      <button mat-menu-item type="button" [disabled]="device.connectionState == 'Disabled'" (click)="restartModules(device.edgeDeviceId)">Restart Modules(s)</button>
                      <button mat-menu-item type="button" [disabled]="device.connectionState == 'Disabled'" (click)="restartDevice(device.edgeDeviceId)">Restart Edge Appliance</button>
                      <button mat-menu-item type="button" (click)="addNewSystemDialog(device)" *ngIf="!device.isChild">Add / Edit System</button>
                      <button mat-menu-item type="button" (click)="showEdgeApplianceDetails(device)">Details</button>
                      <button mat-menu-item type="button" (click)="deprovisionDevice(device.edgeDeviceId)" *ngIf="!device.isChild">Deprovision Device</button>
                      <button
                        mat-menu-item
                        type="button"
                        *ngFor="let action of getDeploymentActions(device); trackBy: trackByActionName"
                        (click)="onDeploymentActionClick(device, action)">
                        {{ getActionLabel(action) }}
                      </button>

                       <!-- Disabling is a root-only action; do not offer it on child rows. -->
                       <button mat-menu-item type="button" *ngIf="!device.isChild" [disabled]="!canDisableDevice(device)" (click)="onDisableDevice(device)">Disable Device</button>
                    </mat-menu>
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row-tables" *ngIf="device.systems?.length">
                <table mat-table [dataSource]="device.systems" class="row-table" tabindex="0" role="table">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef >Name</th>
                    <td mat-cell *matCellDef="let rowdata" data-label="Name" tabindex="0" class="w-[300px] max-w-[300px]">
                      <div style="padding-left:16px" class="flex">
                        <img class="alert-icon" [style.visibility]="rowdata.status === 'Online' ? 'hidden' : 'visible'" src="../../../../../assets/img/icons/ico.16.alert.svg" alt="Alert">
                        <span class="txt-ellipsis" [matTooltipDisabled]="false" [matTooltip]="rowdata?.systemFriendlyName == '' ? rowdata?.systemId : rowdata?.systemFriendlyName" matTooltipPosition="below" matTooltipClass="my-custom-tooltip" [innerHTML]="(rowdata?.systemFriendlyName == '' ? rowdata?.systemId : rowdata?.systemFriendlyName) | noHtml | highlightMatched: filterText"></span>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="site">
                    <th mat-header-cell *matHeaderCellDef>Site</th>
                    <td mat-cell *matCellDef="let rowdata" data-label="Site" tabindex="0" class="w-[200px] max-w-[200px]">
                      <span class="txt-ellipsis" [matTooltipDisabled]="false" [matTooltip]="displaySite(rowdata?.siteId)" matTooltipPosition="below" matTooltipClass="my-custom-tooltip" [innerHTML]="displaySite(rowdata?.siteId) | noHtml | highlightMatched: filterText"></span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef >ID Number</th>
                    <td mat-cell *matCellDef="let rowdata" data-label="Name" tabindex="0" class="w-[200px] max-w-[200px]">
                      <span class="txt-ellipsis" [matTooltipDisabled]="false" [matTooltip]="rowdata?.systemId" matTooltipPosition="below" matTooltipClass="my-custom-tooltip" [innerHTML]="rowdata?.systemId | noHtml | highlightMatched: filterText"></span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef >Status</th>
                    <td mat-cell *matCellDef="let rowdata" [innerHTML]="rowdata.status" data-label="Name" tabindex="0" class="w-[200px] max-w-[200px]" [ngClass]="{'offline': applyColumnClass(rowdata)}"></td>
                  </ng-container>
                  <ng-container matColumnDef="heartbeat">
                    <th mat-header-cell *matHeaderCellDef >CDC Heartbeat</th>
                    <td mat-cell *matCellDef="let rowdata" [innerHTML]="rowdata.cdcHeartbeat | date:'MMM dd - hh:mm aaaaa\'m\''" data-label="Name" tabindex="0"></td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                    <td mat-cell *matCellDef="let rowdata" class="text-right">
                      <button
                        *ngIf="hasAnyRowActions(rowdata)"
                        [matMenuTriggerFor]="systemActionsMenu"
                        class="btn-transparent p-0"
                        (click)="$event.stopPropagation()"
                        (keypress.enter)="$event.stopPropagation()"
                        type="button"
                        [attr.aria-label]="'Actions for ' + (rowdata?.systemFriendlyName || rowdata?.systemId)">
                        <mat-icon class="pointer menu-trigger">
                          <img src='../../../../../assets/img/icons/ico_16_Menu.svg' alt="">
                        </mat-icon>
                      </button>

                      <mat-menu #systemActionsMenu="matMenu" [backdropClass]="['custom_drop', 'provisioned-menu-backdrop']" xPosition="before">
                        <button
                          mat-menu-item
                          type="button"
                          *ngFor="let action of getSystemActions(rowdata); trackBy: trackByActionName"
                          (click)="executeSystemAction(device, rowdata, action)">
                          {{ action.label || action.name }}
                        </button>
                      </mat-menu>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: ['name','site','id','status','heartbeat','actions'];" [ngClass]="{'offline': applyRowClass(row)}"></tr>
                </table>
              </div>
              <div class="child-deployments-wrapper" *ngIf="device.children?.length">
                <div class="child-header-row" (click)="toggleChildDeployments(device, $event)" [class.expanded]="isChildDeploymentsExpanded(device)" role="button" tabindex="0" (keydown.enter)="toggleChildDeployments(device, $event)" (keydown.space)="toggleChildDeployments(device, $event)" [attr.aria-expanded]="isChildDeploymentsExpanded(device)">
                  <span class="mat-expansion-indicator" aria-hidden="true"></span>
                  <span class="child-title">Child Deployments ({{ device.children.length }})</span>
                </div>
                <div class="child-body" *ngIf="isChildDeploymentsExpanded(device)">
                  <div class="m-l-4 border-l pl-4">
                    <ng-container *ngFor="let child of device.children">
                      <ng-container *ngTemplateOutlet="devicePanel; context: { $implicit: child, level: level + 1 }"></ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-template>
        </div>
      </mat-accordion>
    </div>
  </div>
</div>
